import * as React from 'react';
import b_ from 'b_';
import { Money } from 'types/common';
import MoneyView from 'shared/components/MoneyView';
import PercentView from 'components/PercentView';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import {
  TariffGridFragment_tariffGrid as TariffGrid,
  TariffGridFragment_tariffGrid_tariffs as Entry,
} from './__generated__/TariffGridFragment';

import './index.scss';

interface Props {
  grid: TariffGrid;
}

type Enhanced = Props & InjectedTranslateProps;

const b = b_.with('tariff-grid');

class TariffGridView extends React.Component<Enhanced> {
  render() {
    const { t, grid } = this.props;

    if (!grid) {
      return null;
    }

    return (
      <table className={b()}>
        <thead>
          <tr>
            <td rowSpan={2}>{t('Request amount')}</td>
            <td colSpan={3}>{t('Commission')}</td>
          </tr>
          <tr>
            <td>{t('on enter')}</td>
            <td>{t('on leave')}</td>
            <td>{t('on success')}</td>
          </tr>
        </thead>
        <tbody>{grid.tariffs.map((entry) => this.renderEntry(entry))}</tbody>
      </table>
    );
  }

  private renderEntry(entry: Entry) {
    const { t } = this.props;

    const limit: Money = {
      value: entry.requestAmount,
      currency: 'USD',
    };

    return (
      <tr key={entry.requestAmount}>
        <td>
          {t('from')} <MoneyView>{limit}</MoneyView>
        </td>
        <td>
          <PercentView>{entry.enterFee}</PercentView>
        </td>
        <td>
          <PercentView>{entry.leaveFee}</PercentView>
        </td>
        <td>
          <PercentView>{entry.successFee}</PercentView>
        </td>
      </tr>
    );
  }
}

export default translate(TariffGridView);
